import { Locale } from 'modules/i18n';

export const privateChainCardActionsTranslation = {
  [Locale.en]: {
    addToProjectButton: 'Add to project',
  },
};
